import { render } from "./Viewer.vue?vue&type=template&id=9f0916ae&ts=true"
import script from "./Viewer.vue?vue&type=script&lang=ts"
export * from "./Viewer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__